<template>
<v-container pa-0 >
    <v-layout align-center row>

      <v-btn @click="prev" icon class="prev">
        <v-icon large>mdi-chevron-left</v-icon>
      </v-btn>


      <v-carousel v-model="carouselValue"
                  class="carousel"
                  height="auto"
                  width="auto"
                  contain
                  hide-delimiters
                  hide-controls
                  :cycle="cycle"
                  interval="3000"
      >
        <v-carousel-item
            v-for="(item,i) in images"
            :key="i"
            contain
            height="auto"
            width="auto"
        >
          <v-img
              :lazy-src="require('@/assets/img/innovation/loadingBlueGreen.gif')"
              :src="item"
              contain/>
        </v-carousel-item>
      </v-carousel>

      <v-btn @click="next" icon >
        <v-icon large>mdi-chevron-right</v-icon>
      </v-btn>

    </v-layout>
    <v-layout row justify-center>
      <v-btn
          icon
          @click="pause">
        <v-icon dark large>
          {{cycle ? 'mdi-pause' : 'mdi-play'}}
        </v-icon>
      </v-btn>
    </v-layout>
  </v-container>

</template>

<script>
import {values} from "@/utils/values";
import UrlsService from "@/helpers/UrlsService";
import TimeService from "@/helpers/TimeService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";


export default {
  name: "OnBoarding",
  created() {
    this.getImages();
    /*for (let i = 0; i < values.slides.length; i++) {
      this.images.push(require('@/assets/img/onboarding/' + values.slides[i]));
    }*/
  },
  data() {
    return {
      carouselValue: 0,
      images: [],
      cycle: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.isInViewport);
  },
  destroyed() {
    window.removeEventListener('scroll', this.isInViewport);
  },
  methods: {
    isInViewport() {
      const rect = document.querySelector('.prev').getBoundingClientRect();

      this.cycle = rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    },
    next() {
      this.carouselValue = (this.carouselValue + 1) % this.images.length;
    },
    prev() {
      this.carouselValue = (this.carouselValue - 1 + this.images.length) % this.images.length;
    },
    pause() {
      this.cycle = !this.cycle;
    },
    getImages() {
      let requestUrl = {
        url: UrlsService.getOnBoarding,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
      };
      let requestObject = {
        type: "public",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List Slides onboarding",
        //loading: "Waiting for list of slides onboarding...",
        error: "Cannot get slides onboarding...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            let responseImages = responseSuccess;
            this.images = responseImages;
          });
    },
  },
}
</script>

<style scoped>

.carousel {

}

.v-carousel {
  max-height: 90%;
  max-width: 90%;

  .v-responsive {
    height: 100%;
    width: 100%;
  }
}
</style>